var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJdfxLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.742,
    height: 181.307,
    viewBox: "0 0 182.742 181.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2282",
    "data-name": "Rectangle 2282",
    width: 164.16,
    height: 162.513,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1791",
    "data-name": "Group 1791",
    transform: "translate(0 20.006) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1790",
    "data-name": "Group 1790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5096",
    "data-name": "Path 5096",
    d: "M163.307,81.426A80.77,80.77,0,1,1,82.537.656a80.77,80.77,0,0,1,80.77,80.77",
    transform: "translate(-0.459 -0.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5097",
    "data-name": "Path 5097",
    d: "M143.139,84.225A49.689,49.689,0,1,1,93.451,34.537a49.689,49.689,0,0,1,49.688,49.688",
    transform: "translate(-11.373 -8.976)",
    fill: "#d9ff50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5098",
    "data-name": "Path 5098",
    d: "M91.964,100.6s5.689-.446,6.822-1.493c1.186-1.094,1.707-2.619,1.753-6.907s-.056-17.416-.056-17.416-5.115-.483-6.856,2.724a10.489,10.489,0,0,0-1.515,5.748c-.039,3.726-.148,17.344-.148,17.344",
    transform: "translate(-23.9 -19.43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5099",
    "data-name": "Path 5099",
    d: "M116.385,90.012a51.1,51.1,0,0,1,1.12-10.077c.437-2.239,2.157-3.9,3.468-3.9s1.8.656,2.812,2.13.847,5.653.847,5.653l-.466,14.455s-5.87-.147-6.717-.528-1.01-1.939-1.065-3.277,0-4.451,0-4.451",
    transform: "translate(-30.24 -19.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5100",
    "data-name": "Path 5100",
    d: "M141.136,92.407a49.638,49.638,0,0,1-9.038,28.46,48.489,48.489,0,0,1-22.8,17.539,47.367,47.367,0,0,1-29.588.71A49.635,49.635,0,0,1,51.5,66.138a48.713,48.713,0,0,1,21.386-19.2,47.319,47.319,0,0,1,29.426-3.029,49.575,49.575,0,0,1,38.257,40.947,51.267,51.267,0,0,1,.567,7.551c0,.762,3.22.229,3.217-.861a50.35,50.35,0,0,0-33.742-47.422A52.988,52.988,0,0,0,52.907,60.1a50.318,50.318,0,0,0,18.53,78.333,52.275,52.275,0,0,0,31.506,3.151,53.038,53.038,0,0,0,27.243-14.934,50.535,50.535,0,0,0,13.569-27.236,52.508,52.508,0,0,0,.6-7.866c0-.756-3.214-.23-3.217.861",
    transform: "translate(-10.721 -10.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5101",
    "data-name": "Path 5101",
    d: "M160.943,81.686a80.246,80.246,0,0,1-14.685,46.154,79.2,79.2,0,0,1-37.238,28.539,78.08,78.08,0,0,1-48.472,1.365A80.177,80.177,0,0,1,14.691,39.55,79.387,79.387,0,0,1,49.66,8.358,78.169,78.169,0,0,1,97.836,3.3a80.129,80.129,0,0,1,62.172,66.087,81.975,81.975,0,0,1,.935,12.3c0,.76,3.219.229,3.217-.861A80.952,80.952,0,0,0,110.452,4.748,82.448,82.448,0,0,0,85.343.042,83.773,83.773,0,0,0,36.784,13.729,81.7,81.7,0,0,0,6,50.969,80.267,80.267,0,0,0,.232,75.411a81.649,81.649,0,0,0,2.1,25.615,80.181,80.181,0,0,0,9.525,22.74,81.063,81.063,0,0,0,60.563,38.272,84.119,84.119,0,0,0,49.751-10.1,83,83,0,0,0,19.387-14.944,81.571,81.571,0,0,0,14.106-19.976,80.125,80.125,0,0,0,7.548-23.7,83.222,83.222,0,0,0,.946-12.492c0-.757-3.216-.23-3.217.861",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5102",
    "data-name": "Path 5102",
    d: "M59.167,125.274a5.672,5.672,0,0,0,6.3,1.134,5.867,5.867,0,0,0,2.79-3.063h.126a4.911,4.911,0,0,1-7.081,4.281,4.965,4.965,0,0,1-2.245-2.3Z",
    transform: "translate(-15.347 -32.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5103",
    "data-name": "Path 5103",
    d: "M152.125,121.371a5.225,5.225,0,0,0,7.809,3.755l.1.078a4.59,4.59,0,0,1-7.687-.878A4.646,4.646,0,0,1,152,121.34Z",
    transform: "translate(-39.476 -31.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5104",
    "data-name": "Path 5104",
    d: "M130.33,123.968c.556.91,1.2,2.173,2.276,2.43l.835-.016c-.266.61-1.078,2.7-1.356,3.351a11.338,11.338,0,0,1-5.781,5.983c-3.5,1.626-9.3-.241-10.956-1.27a49.842,49.842,0,0,0-10.974-3.011,11.9,11.9,0,0,0-6.6,1.042,72.452,72.452,0,0,0-8.962,6.229c-5.076,3.733-13.223,5.211-17.926.135l.413.339a11.607,11.607,0,0,1-3.867-5.251,26.692,26.692,0,0,1-1.673-5.782l.283-.089c1.31,3.521,2.815,7.514,6.066,9.663,2.96,2.75,7.691,2.67,11.228,1.095a18.5,18.5,0,0,0,5.032-3.2,60.646,60.646,0,0,1,7.384-5.358,13.745,13.745,0,0,1,8.937-1.677,46.754,46.754,0,0,1,11.621,3.555c4.411,2.616,9.772,3.44,13.352-.966a21.4,21.4,0,0,0,2.632-4.186l.1.234c-1.314-.488-1.864-1.952-2.345-3.152l.281-.095",
    transform: "translate(-17.089 -32.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5105",
    "data-name": "Path 5105",
    d: "M16.783,90.342l.252-1.625,6.851,1.059q2.936.456,3.484,1.569.461.937-.078,4.412-.523,3.38-1.352,4.2-.926.917-3.7.488l.252-1.626q1.882.291,2.406-.2t.929-3.1q.4-2.609.056-3.217t-2.248-.9Z",
    transform: "translate(-4.362 -23.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5106",
    "data-name": "Path 5106",
    d: "M16.783,90.342l.252-1.625,6.851,1.059q2.936.456,3.484,1.569.461.937-.078,4.412-.523,3.38-1.352,4.2-.926.917-3.7.488l.252-1.626q1.882.291,2.406-.2t.929-3.1q.4-2.609.056-3.217t-2.248-.9Z",
    transform: "translate(-4.362 -23.056)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5107",
    "data-name": "Path 5107",
    d: "M26.4,79.923q1.2.476,1.744-.081a13.753,13.753,0,0,0,1.685-3.437,13.865,13.865,0,0,0,1.138-3.68q-.017-.769-1.218-1.246L22.465,68.59l.606-1.53,7.285,2.889q2.117.839,2.265,1.87.173,1.145-1.41,5.133t-2.437,4.657q-.861.684-2.98-.157l-7.285-2.889.607-1.53Z",
    transform: "translate(-4.81 -17.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5108",
    "data-name": "Path 5108",
    d: "M26.4,79.923q1.2.476,1.744-.081a13.753,13.753,0,0,0,1.685-3.437,13.865,13.865,0,0,0,1.138-3.68q-.017-.769-1.218-1.246L22.465,68.59l.606-1.53,7.285,2.889q2.117.839,2.265,1.87.173,1.145-1.41,5.133t-2.437,4.657q-.861.684-2.98-.157l-7.285-2.889.607-1.53Z",
    transform: "translate(-4.81 -17.428)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5109",
    "data-name": "Path 5109",
    d: "M35.394,56.4a15.413,15.413,0,0,1,3.165-3.71q1.178-.691,2.932.545a2.578,2.578,0,0,1,1.313,2.76,15.3,15.3,0,0,1-2.44,4.36q-2.332,3.311-3.726,3.749-1.065.335-2.925-.975l.948-1.346q1.279.9,2,.562a10.277,10.277,0,0,0,2.5-2.859,16.094,16.094,0,0,0,2.016-3.366,1.3,1.3,0,0,0-.632-1.54q-.924-.651-1.534-.261a14.415,14.415,0,0,0-2.4,2.935q-2.194,3.113-3.7,3.652a2.834,2.834,0,0,1-2.621-.622q-1.6-1.125-1.372-2.437a13.515,13.515,0,0,1,2.36-4.347q2.128-3.02,3.523-3.459a3.366,3.366,0,0,1,2.8.847L36.67,52.2q-1.17-.824-1.893-.446a9.469,9.469,0,0,0-2.285,2.594q-1.339,1.9-1.592,2.372-.77,1.431.33,2.206a1.536,1.536,0,0,0,1.761.174,10.17,10.17,0,0,0,2.4-2.708",
    transform: "translate(-7.508 -12.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5110",
    "data-name": "Path 5110",
    d: "M35.394,56.4a15.413,15.413,0,0,1,3.165-3.71q1.178-.691,2.932.545a2.578,2.578,0,0,1,1.313,2.76,15.3,15.3,0,0,1-2.44,4.36q-2.332,3.311-3.726,3.749-1.065.335-2.925-.975l.948-1.346q1.279.9,2,.562a10.277,10.277,0,0,0,2.5-2.859,16.094,16.094,0,0,0,2.016-3.366,1.3,1.3,0,0,0-.632-1.54q-.924-.651-1.534-.261a14.415,14.415,0,0,0-2.4,2.935q-2.194,3.113-3.7,3.652a2.834,2.834,0,0,1-2.621-.622q-1.6-1.125-1.372-2.437a13.515,13.515,0,0,1,2.36-4.347q2.128-3.02,3.523-3.459a3.366,3.366,0,0,1,2.8.847L36.67,52.2q-1.17-.824-1.893-.446a9.469,9.469,0,0,0-2.285,2.594q-1.339,1.9-1.592,2.372-.77,1.431.33,2.206a1.536,1.536,0,0,0,1.761.174A10.17,10.17,0,0,0,35.394,56.4Z",
    transform: "translate(-7.508 -12.984)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5111",
    "data-name": "Path 5111",
    d: "M40.8,41.178l8.566-7.728.994,1.1L46.694,37.86l6.409,7.1-1.222,1.1-6.409-7.1L41.794,42.28Z",
    transform: "translate(-10.603 -8.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5112",
    "data-name": "Path 5112",
    d: "M40.8,41.178l8.566-7.728.994,1.1L46.694,37.86l6.409,7.1-1.222,1.1-6.409-7.1L41.794,42.28Z",
    transform: "translate(-10.603 -8.693)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5113",
    "data-name": "Path 5113",
    d: "M67.385,22.438l8.646-3.32a3.9,3.9,0,0,1,2.878-.292q1.43.663,2.734,4.057,1.3,3.378.679,4.828a3.842,3.842,0,0,1-2.327,1.725l-8.645,3.32Zm4.968,8.342,7.094-2.725q1.25-.48,1.386-1.407a7.487,7.487,0,0,0-.727-3.176,7.374,7.374,0,0,0-1.591-2.835,1.876,1.876,0,0,0-1.967-.127l-7.095,2.725Z",
    transform: "translate(-17.512 -4.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5114",
    "data-name": "Path 5114",
    d: "M67.385,22.438l8.646-3.32a3.9,3.9,0,0,1,2.878-.292q1.43.663,2.734,4.057,1.3,3.378.679,4.828a3.842,3.842,0,0,1-2.327,1.725l-8.645,3.32Zm4.968,8.342,7.094-2.725q1.25-.48,1.386-1.407a7.487,7.487,0,0,0-.727-3.176,7.374,7.374,0,0,0-1.591-2.835,1.876,1.876,0,0,0-1.967-.127l-7.095,2.725Z",
    transform: "translate(-17.512 -4.849)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5115",
    "data-name": "Path 5115",
    d: "M90.975,15.181l10.487-1.312.184,1.473L92.792,16.45l.4,3.2,8.549-1.069.184,1.473-8.549,1.069L93.8,24.47l8.853-1.108.184,1.473L92.348,26.148Z",
    transform: "translate(-23.643 -3.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5116",
    "data-name": "Path 5116",
    d: "M90.975,15.181l10.487-1.312.184,1.473L92.792,16.45l.4,3.2,8.549-1.069.184,1.473-8.549,1.069L93.8,24.47l8.853-1.108.184,1.473L92.348,26.148Z",
    transform: "translate(-23.643 -3.604)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5117",
    "data-name": "Path 5117",
    d: "M117.114,19.08a15.424,15.424,0,0,1,4.789.927q1.18.685.97,2.82a2.575,2.575,0,0,1-1.755,2.5,15.261,15.261,0,0,1-5,.026q-4.03-.4-5.1-1.4-.817-.762-.593-3.026l1.638.162q-.154,1.558.5,2.019a10.254,10.254,0,0,0,3.718.765,16.076,16.076,0,0,0,3.923.1,1.3,1.3,0,0,0,1.029-1.309q.111-1.123-.528-1.463a14.473,14.473,0,0,0-3.738-.645q-3.79-.374-5-1.418a2.834,2.834,0,0,1-.75-2.587q.192-1.943,1.445-2.4a13.505,13.505,0,0,1,4.945-.087q3.676.364,4.746,1.361A3.363,3.363,0,0,1,123,18.283l-1.606-.158q.141-1.423-.545-1.867a9.453,9.453,0,0,0-3.383-.71q-2.311-.229-2.849-.217-1.625.036-1.757,1.374a1.538,1.538,0,0,0,.716,1.618,10.161,10.161,0,0,0,3.54.756",
    transform: "translate(-28.686 -3.614)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5118",
    "data-name": "Path 5118",
    d: "M117.114,19.08a15.424,15.424,0,0,1,4.789.927q1.18.685.97,2.82a2.575,2.575,0,0,1-1.755,2.5,15.261,15.261,0,0,1-5,.026q-4.03-.4-5.1-1.4-.817-.762-.593-3.026l1.638.162q-.154,1.558.5,2.019a10.254,10.254,0,0,0,3.718.765,16.076,16.076,0,0,0,3.923.1,1.3,1.3,0,0,0,1.029-1.309q.111-1.123-.528-1.463a14.473,14.473,0,0,0-3.738-.645q-3.79-.374-5-1.418a2.834,2.834,0,0,1-.75-2.587q.192-1.943,1.445-2.4a13.505,13.505,0,0,1,4.945-.087q3.676.364,4.746,1.361A3.363,3.363,0,0,1,123,18.283l-1.606-.158q.141-1.423-.545-1.867a9.453,9.453,0,0,0-3.383-.71q-2.311-.229-2.849-.217-1.625.036-1.757,1.374a1.538,1.538,0,0,0,.716,1.618A10.161,10.161,0,0,0,117.114,19.08Z",
    transform: "translate(-28.686 -3.614)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2278",
    "data-name": "Rectangle 2278",
    width: 11.052,
    height: 1.646,
    transform: "translate(96.161 22.998) rotate(-75.407)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2279",
    "data-name": "Rectangle 2279",
    width: 11.052,
    height: 1.646,
    transform: "translate(96.161 22.998) rotate(-75.407)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5119",
    "data-name": "Path 5119",
    d: "M139.116,24.34q-1.247,2.79-.88,3.591t3.606,2.25q3.167,1.415,3.986,1.34t1.657-1.946l-4.86-2.173.606-1.355,6.363,2.844-.6,1.351q-1.162,2.6-2.528,2.809t-5.226-1.516q-3.917-1.752-4.532-3.1t.917-4.779q1.532-3.427,2.932-3.851t5.333,1.334q3.874,1.732,4.667,2.784t-.221,3.321l-1.5-.671q.655-1.469.085-2.089a14.475,14.475,0,0,0-3.635-1.99q-3.269-1.462-4.089-1.209t-2.074,3.057",
    transform: "translate(-35.481 -5.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5120",
    "data-name": "Path 5120",
    d: "M139.116,24.34q-1.247,2.79-.88,3.591t3.606,2.25q3.167,1.415,3.986,1.34t1.657-1.946l-4.86-2.173.606-1.355,6.363,2.844-.6,1.351q-1.162,2.6-2.528,2.809t-5.226-1.516q-3.917-1.752-4.532-3.1t.917-4.779q1.532-3.427,2.932-3.851t5.333,1.334q3.874,1.732,4.667,2.784t-.221,3.321l-1.5-.671q.655-1.469.085-2.089a14.475,14.475,0,0,0-3.635-1.99q-3.269-1.462-4.089-1.209T139.116,24.34Z",
    transform: "translate(-35.481 -5.125)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5121",
    "data-name": "Path 5121",
    d: "M161.126,29.047l1.867,1.515,1.254,13.485,6.1-7.517,1.278,1.037-6.965,8.582-1.929-1.565-1.242-13.372-6.05,7.454-1.277-1.038Z",
    transform: "translate(-40.064 -7.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5122",
    "data-name": "Path 5122",
    d: "M161.126,29.047l1.867,1.515,1.254,13.485,6.1-7.517,1.278,1.037-6.965,8.582-1.929-1.565-1.242-13.372-6.05,7.454-1.277-1.038Z",
    transform: "translate(-40.064 -7.549)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5123",
    "data-name": "Path 5123",
    d: "M181.984,59.818l-4,2.306-.823-1.425,9.573-5.523,5.121,8.874-1.286.742-4.3-7.449-3,1.734,4.137,7.169-1.286.742Z",
    transform: "translate(-46.042 -14.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5124",
    "data-name": "Path 5124",
    d: "M181.984,59.818l-4,2.306-.823-1.425,9.573-5.523,5.121,8.874-1.286.742-4.3-7.449-3,1.734,4.137,7.169-1.286.742Z",
    transform: "translate(-46.042 -14.339)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5125",
    "data-name": "Path 5125",
    d: "M193.924,80.928l5.653,3.145.668,2.242-6.75-3.862-3.809,7.13-.641-2.149,3.239-6.017-.06-.2-6.006-3.259-.628-2.1,7.093,3.878,3.531-6.93.651,2.18-3,5.745Z",
    transform: "translate(-48.232 -18.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5126",
    "data-name": "Path 5126",
    d: "M193.924,80.928l5.653,3.145.668,2.242-6.75-3.862-3.809,7.13-.641-2.149,3.239-6.017-.06-.2-6.006-3.259-.628-2.1,7.093,3.878,3.531-6.93.651,2.18-3,5.745Z",
    transform: "translate(-48.232 -18.92)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5127",
    "data-name": "Path 5127",
    d: "M201.649,95.9h.016a2.807,2.807,0,1,1,.622,5.579l-.016,0a2.807,2.807,0,1,1-.622-5.58m.586,5.259h.017a2.484,2.484,0,1,0-.552-4.937h-.016a2.484,2.484,0,1,0,.551,4.937m1.078-3.67.136,1.251a.919.919,0,0,1-.753,1.137.87.87,0,0,1-.924-.6l-1.005.9-.061-.562.95-.817-.073-.673-1.027.111-.049-.449Zm-1.28,1.356c.044.4.277.6.581.57.337-.037.471-.295.429-.679l-.081-.754-1.01.11Z",
    transform: "translate(-51.754 -24.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5128",
    "data-name": "Path 5128",
    d: "M201.649,95.9h.016a2.807,2.807,0,1,1,.622,5.579l-.016,0a2.807,2.807,0,1,1-.622-5.58Zm.586,5.259h.017a2.484,2.484,0,1,0-.552-4.937h-.016a2.484,2.484,0,1,0,.551,4.937Zm1.078-3.67.136,1.251a.919.919,0,0,1-.753,1.137.87.87,0,0,1-.924-.6l-1.005.9-.061-.562.95-.817-.073-.673-1.027.111-.049-.449Zm-1.28,1.356c.044.4.277.6.581.57.337-.037.471-.295.429-.679l-.081-.754-1.01.11Z",
    transform: "translate(-51.754 -24.919)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5129",
    "data-name": "Path 5129",
    d: "M201.4,124.128l-.235,1.629-6.861-.99q-2.942-.425-3.5-1.533-.47-.931.033-4.413.488-3.386,1.309-4.213.917-.928,3.7-.526l-.235,1.628q-1.884-.271-2.4.223t-.9,3.108q-.377,2.612-.023,3.217t2.257.879Z",
    transform: "translate(-49.527 -29.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5130",
    "data-name": "Path 5130",
    d: "M201.4,124.128l-.235,1.629-6.861-.99q-2.942-.425-3.5-1.533-.47-.931.033-4.413.488-3.386,1.309-4.213.917-.928,3.7-.526l-.235,1.628q-1.884-.271-2.4.223t-.9,3.108q-.377,2.612-.023,3.217t2.257.879Z",
    transform: "translate(-49.527 -29.616)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5131",
    "data-name": "Path 5131",
    d: "M190.707,133.627q-1.207-.464-1.743.1a13.766,13.766,0,0,0-1.65,3.453,13.848,13.848,0,0,0-1.1,3.691q.023.769,1.23,1.235l7.315,2.817-.591,1.535-7.314-2.815q-2.126-.819-2.284-1.848-.183-1.142,1.359-5.148,1.538-3.99,2.391-4.681t2.981.128l7.313,2.815-.591,1.536Z",
    transform: "translate(-47.961 -34.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5132",
    "data-name": "Path 5132",
    d: "M190.707,133.627q-1.207-.464-1.743.1a13.766,13.766,0,0,0-1.65,3.453,13.848,13.848,0,0,0-1.1,3.691q.023.769,1.23,1.235l7.315,2.817-.591,1.535-7.314-2.815q-2.126-.819-2.284-1.848-.183-1.142,1.359-5.148,1.538-3.99,2.391-4.681t2.981.128l7.313,2.815-.591,1.536Z",
    transform: "translate(-47.961 -34.213)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5133",
    "data-name": "Path 5133",
    d: "M182.033,157.419a15.386,15.386,0,0,1-3.128,3.743q-1.169.7-2.936-.514a2.577,2.577,0,0,1-1.342-2.747,15.255,15.255,0,0,1,2.394-4.384q2.3-3.336,3.687-3.789,1.061-.345,2.935.945l-.934,1.355q-1.288-.888-2.008-.541a10.269,10.269,0,0,0-2.467,2.885,16.082,16.082,0,0,0-1.981,3.387,1.3,1.3,0,0,0,.648,1.534q.929.641,1.536.245a14.4,14.4,0,0,0,2.372-2.96q2.16-3.135,3.658-3.69a2.835,2.835,0,0,1,2.627.6q1.608,1.108,1.4,2.422a13.507,13.507,0,0,1-2.314,4.37q-2.1,3.044-3.486,3.5a3.366,3.366,0,0,1-2.807-.816l.915-1.328q1.178.81,1.9.426a9.5,9.5,0,0,0,2.257-2.619q1.319-1.914,1.567-2.389.755-1.439-.352-2.2a1.536,1.536,0,0,0-1.763-.155,10.157,10.157,0,0,0-2.374,2.733",
    transform: "translate(-45.368 -38.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5134",
    "data-name": "Path 5134",
    d: "M182.033,157.419a15.386,15.386,0,0,1-3.128,3.743q-1.169.7-2.936-.514a2.577,2.577,0,0,1-1.342-2.747,15.255,15.255,0,0,1,2.394-4.384q2.3-3.336,3.687-3.789,1.061-.345,2.935.945l-.934,1.355q-1.288-.888-2.008-.541a10.269,10.269,0,0,0-2.467,2.885,16.082,16.082,0,0,0-1.981,3.387,1.3,1.3,0,0,0,.648,1.534q.929.641,1.536.245a14.4,14.4,0,0,0,2.372-2.96q2.16-3.135,3.658-3.69a2.835,2.835,0,0,1,2.627.6q1.608,1.108,1.4,2.422a13.507,13.507,0,0,1-2.314,4.37q-2.1,3.044-3.486,3.5a3.366,3.366,0,0,1-2.807-.816l.915-1.328q1.178.81,1.9.426a9.5,9.5,0,0,0,2.257-2.619q1.319-1.914,1.567-2.389.755-1.439-.352-2.2a1.536,1.536,0,0,0-1.763-.155A10.157,10.157,0,0,0,182.033,157.419Z",
    transform: "translate(-45.368 -38.893)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5135",
    "data-name": "Path 5135",
    d: "M177.325,173.295l-8.488,7.813-1.005-1.093,3.632-3.344-6.48-7.038,1.212-1.115,6.48,7.039,3.644-3.355Z",
    transform: "translate(-42.877 -43.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5136",
    "data-name": "Path 5136",
    d: "M177.325,173.295l-8.488,7.813-1.005-1.093,3.632-3.344-6.48-7.038,1.212-1.115,6.48,7.039,3.644-3.355Z",
    transform: "translate(-42.877 -43.795)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5137",
    "data-name": "Path 5137",
    d: "M149.964,191.747l-8.611,3.411a3.9,3.9,0,0,1-2.874.321q-1.437-.648-2.775-4.028t-.73-4.821a3.843,3.843,0,0,1,2.309-1.748l8.611-3.411Zm-5.054-8.289-7.065,2.8q-1.244.494-1.371,1.422a7.458,7.458,0,0,0,.76,3.168,7.355,7.355,0,0,0,1.619,2.819,1.879,1.879,0,0,0,1.969.107l7.065-2.8Z",
    transform: "translate(-35.029 -47.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5138",
    "data-name": "Path 5138",
    d: "M149.964,191.747l-8.611,3.411a3.9,3.9,0,0,1-2.874.321q-1.437-.648-2.775-4.028t-.73-4.821a3.843,3.843,0,0,1,2.309-1.748l8.611-3.411Zm-5.054-8.289-7.065,2.8q-1.244.494-1.371,1.422a7.458,7.458,0,0,0,.76,3.168,7.355,7.355,0,0,0,1.619,2.819,1.879,1.879,0,0,0,1.969.107l7.065-2.8Z",
    transform: "translate(-35.029 -47.161)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5139",
    "data-name": "Path 5139",
    d: "M127.585,199.879l-10.472,1.42-.2-1.471,8.841-1.2-.434-3.2-8.537,1.158-.2-1.471,8.537-1.157-.452-3.342-8.842,1.2-.2-1.471,10.472-1.42Z",
    transform: "translate(-30.05 -49.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5140",
    "data-name": "Path 5140",
    d: "M127.585,199.879l-10.472,1.42-.2-1.471,8.841-1.2-.434-3.2-8.537,1.158-.2-1.471,8.537-1.157-.452-3.342-8.842,1.2-.2-1.471,10.472-1.42Z",
    transform: "translate(-30.05 -49.099)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5141",
    "data-name": "Path 5141",
    d: "M101.16,196.5a15.351,15.351,0,0,1-4.8-.879q-1.188-.672-1-2.809a2.577,2.577,0,0,1,1.73-2.52,15.278,15.278,0,0,1,5-.076q4.034.356,5.113,1.343.824.754.624,3.019l-1.639-.144q.138-1.559-.518-2.014a10.256,10.256,0,0,0-3.726-.726,16.066,16.066,0,0,0-3.923-.056A1.3,1.3,0,0,0,97,192.961q-.1,1.125.543,1.457a14.483,14.483,0,0,0,3.745.606q3.793.335,5.014,1.367a2.831,2.831,0,0,1,.776,2.579q-.171,1.945-1.42,2.41a13.518,13.518,0,0,1-4.945.138q-3.679-.326-4.759-1.311a3.362,3.362,0,0,1-.671-2.846l1.607.143q-.127,1.424.564,1.861a9.488,9.488,0,0,0,3.39.675q2.315.2,2.851.187,1.624-.052,1.742-1.391a1.536,1.536,0,0,0-.732-1.61,10.158,10.158,0,0,0-3.548-.72",
    transform: "translate(-24.755 -49.397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M101.16,196.5a15.351,15.351,0,0,1-4.8-.879q-1.188-.672-1-2.809a2.577,2.577,0,0,1,1.73-2.52,15.278,15.278,0,0,1,5-.076q4.034.356,5.113,1.343.824.754.624,3.019l-1.639-.144q.138-1.559-.518-2.014a10.256,10.256,0,0,0-3.726-.726,16.066,16.066,0,0,0-3.923-.056A1.3,1.3,0,0,0,97,192.961q-.1,1.125.543,1.457a14.483,14.483,0,0,0,3.745.606q3.793.335,5.014,1.367a2.831,2.831,0,0,1,.776,2.579q-.171,1.945-1.42,2.41a13.518,13.518,0,0,1-4.945.138q-3.679-.326-4.759-1.311a3.362,3.362,0,0,1-.671-2.846l1.607.143q-.127,1.424.564,1.861a9.488,9.488,0,0,0,3.39.675q2.315.2,2.851.187,1.624-.052,1.742-1.391a1.536,1.536,0,0,0-.732-1.61A10.158,10.158,0,0,0,101.16,196.5Z",
    transform: "translate(-24.755 -49.397)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2280",
    "data-name": "Rectangle 2280",
    width: 11.052,
    height: 1.646,
    transform: "translate(64.309 149.976) rotate(-75.995)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2281",
    "data-name": "Rectangle 2281",
    width: 11.052,
    height: 1.646,
    transform: "translate(64.309 149.976) rotate(-75.995)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M78.492,190.866q1.219-2.8.844-3.6t-3.63-2.213q-3.181-1.382-4-1.3t-1.636,1.962l4.883,2.123L74.36,189.2l-6.392-2.779.591-1.357q1.136-2.611,2.5-2.835t5.241,1.462q3.936,1.711,4.565,3.056t-.867,4.788q-1.5,3.443-2.892,3.881t-5.347-1.279q-3.891-1.692-4.7-2.735t.187-3.324l1.51.656q-.642,1.475-.064,2.089a14.5,14.5,0,0,0,3.655,1.952q3.285,1.428,4.1,1.166t2.042-3.078",
    transform: "translate(-17.334 -47.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M78.492,190.866q1.219-2.8.844-3.6t-3.63-2.213q-3.181-1.382-4-1.3t-1.636,1.962l4.883,2.123L74.36,189.2l-6.392-2.779.591-1.357q1.136-2.611,2.5-2.835t5.241,1.462q3.936,1.711,4.565,3.056t-.867,4.788q-1.5,3.443-2.892,3.881t-5.347-1.279q-3.891-1.692-4.7-2.735t.187-3.324l1.51.656q-.642,1.475-.064,2.089a14.5,14.5,0,0,0,3.655,1.952q3.285,1.428,4.1,1.166T78.492,190.866Z",
    transform: "translate(-17.334 -47.352)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M55.327,185.064l-1.881-1.5L52.056,170.1l-6.025,7.578-1.288-1.024L51.621,168l1.946,1.547L54.943,182.9l5.975-7.514,1.288,1.024Z",
    transform: "translate(-11.628 -43.66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M55.327,185.064l-1.881-1.5L52.056,170.1l-6.025,7.578-1.288-1.024L51.621,168l1.946,1.547L54.943,182.9l5.975-7.514,1.288,1.024Z",
    transform: "translate(-11.628 -43.66)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M35.133,156.362l3.973-2.347.837,1.417-9.516,5.622-5.211-8.821,1.278-.756,4.373,7.4,2.986-1.764-4.209-7.127,1.278-.756Z",
    transform: "translate(-6.553 -38.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M35.133,156.362l3.973-2.347.837,1.417-9.516,5.622-5.211-8.821,1.278-.756,4.373,7.4,2.986-1.764-4.209-7.127,1.278-.756Z",
    transform: "translate(-6.553 -38.784)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    d: "M22.981,133.629l-5.686-3.086-.691-2.235,6.791,3.792,3.733-7.17.663,2.142-3.176,6.051.062.2,6.04,3.2.649,2.1-7.133-3.8-3.457,6.966-.674-2.173,2.941-5.775Z",
    transform: "translate(-4.315 -32.467)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M22.981,133.629l-5.686-3.086-.691-2.235,6.791,3.792,3.733-7.17.663,2.142-3.176,6.051.062.2,6.04,3.2.649,2.1-7.133-3.8-3.457,6.966-.674-2.173,2.941-5.775Z",
    transform: "translate(-4.315 -32.467)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M18.291,122.626l-.016,0a2.808,2.808,0,1,1-.68-5.575l.016,0a2.808,2.808,0,1,1,.68,5.575m-.642-5.254h-.016a2.485,2.485,0,1,0,.6,4.934h.016a2.485,2.485,0,1,0-.6-4.934m-1.04,3.683-.149-1.25a.919.919,0,0,1,.741-1.144.869.869,0,0,1,.932.588l1-.916.067.562-.941.827.08.673,1.026-.122.053.449Zm1.267-1.37c-.047-.4-.283-.6-.588-.564-.336.04-.468.3-.422.685l.09.753,1.01-.12Z",
    transform: "translate(-3.929 -30.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M18.291,122.626l-.016,0a2.808,2.808,0,1,1-.68-5.575l.016,0a2.808,2.808,0,1,1,.68,5.575Zm-.642-5.254h-.016a2.485,2.485,0,1,0,.6,4.934h.016a2.485,2.485,0,1,0-.6-4.934Zm-1.04,3.683-.149-1.25a.919.919,0,0,1,.741-1.144.869.869,0,0,1,.932.588l1-.916.067.562-.941.827.08.673,1.026-.122.053.449Zm1.267-1.37c-.047-.4-.283-.6-.588-.564-.336.04-.468.3-.422.685l.09.753,1.01-.12Z",
    transform: "translate(-3.929 -30.414)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdfxLogoBlack);
export default __webpack_public_path__ + "static/media/jdfx-logo-black.a50d5e28aefe51c850a0ebd8aa9ca0db.svg";
export { ForwardRef as ReactComponent };